import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20e59b4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "module-show",
  class: "row h-100"
}
const _hoisted_2 = { class: "col-md-6 offset-md-3 mt-5 inner" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"bread-crumbs mb-4 loading\" data-v-20e59b4c><span class=\"me-4 invisible\" data-v-20e59b4c>Standard onboarding</span><span class=\"invisible\" data-v-20e59b4c>Marketing team planning</span></div><p class=\"subtitle mt-2 mb-0 loading\" data-v-20e59b4c><span class=\"invisible\" data-v-20e59b4c> Use case scope</span></p><div class=\"d-flex align-items-center justify-content-between\" data-v-20e59b4c><h1 class=\"mb-0 loading\" data-v-20e59b4c></h1></div><br data-v-20e59b4c><div class=\"description mb-0 loading\" data-v-20e59b4c><div class=\"invisible\" data-v-20e59b4c>Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum</div></div><br data-v-20e59b4c><br data-v-20e59b4c>", 7)
const _hoisted_10 = { class: "d-flex mt-2" }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"deadline d-flex me-3 loading\" data-v-20e59b4c><span class=\"title me-1 invisible\" data-v-20e59b4c>Deadline</span><span class=\"data invisible\" data-v-20e59b4c>August 2</span></div><div class=\"tasks d-flex me-3 loading\" data-v-20e59b4c><span class=\"title me-1 invisible\" data-v-20e59b4c>Tasks</span><span class=\"invisible\" data-v-20e59b4c>13/50</span></div>", 2)
const _hoisted_13 = {
  key: 0,
  class: "assigness d-flex align-items-center loading"
}
const _hoisted_14 = {
  key: 1,
  class: "assigness d-flex align-items-center"
}
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<hr data-v-20e59b4c><div class=\"blocks mt-5 loading\" data-v-20e59b4c><p class=\"invisible\" data-v-20e59b4c>lorem ipsum</p></div><div class=\"blocks mt-2 loading\" data-v-20e59b4c><p class=\"invisible\" data-v-20e59b4c>lorem ipsum</p></div><div class=\"blocks mt-2 loading\" data-v-20e59b4c><p class=\"invisible\" data-v-20e59b4c>lorem ipsum</p></div><div class=\"blocks mt-2 loading\" data-v-20e59b4c><p class=\"invisible\" data-v-20e59b4c>lorem ipsum</p></div><div class=\"blocks mt-2 loading\" data-v-20e59b4c><p class=\"invisible\" data-v-20e59b4c>lorem ipsum</p></div><div class=\"blocks mt-2 loading\" data-v-20e59b4c><p class=\"invisible\" data-v-20e59b4c>lorem ipsum</p></div><div class=\"blocks mt-2 loading\" data-v-20e59b4c><p class=\"invisible\" data-v-20e59b4c>lorem ipsum</p></div><div class=\"blocks mt-2 loading\" data-v-20e59b4c><p class=\"invisible\" data-v-20e59b4c>lorem ipsum</p></div><div class=\"blocks mt-2 loading\" data-v-20e59b4c><p class=\"invisible\" data-v-20e59b4c>lorem ipsum</p></div>", 10)
const _hoisted_26 = {
  "data-bs-toggle": "modal",
  "data-bs-target": "#loginModal",
  ref: "loginModalBtn"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LogoAndName = _resolveComponent("LogoAndName")!
  const _component_LoginCodeModal = _resolveComponent("LoginCodeModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        (_ctx.userList.length <= 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userList, (user, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "me-3 invisible",
                  key: i
                }, [
                  _createVNode(_component_LogoAndName, {
                    user: user,
                    rowView: true
                  }, null, 8, ["user"])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userList, (user, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "me-3",
                  key: i
                }, [
                  (user.avatar)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: user.avatar,
                        class: "avatar",
                        alt: "avatar"
                      }, null, 8, _hoisted_15))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
      ]),
      _hoisted_16
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_26, "hidden btn", 512), [
      [_vShow, false]
    ]),
    _createVNode(_component_LoginCodeModal, {
      email: _ctx.emailAddress,
      redirectTo: _ctx.redirectTo
    }, null, 8, ["email", "redirectTo"])
  ]))
}